import React, { useState, useEffect, useRef } from 'react';
import style from './AccessibilitySetting.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import SwitchBox from '../../../../components/box/SwitchBox';
import contrast01 from '../../../../images/common/i_hi_contrast_01.svg';
import contrastArrow from '../../../../images/common/i_hi_contrast_arrow.svg';
import contrast02 from '../../../../images/common/i_hi_contrast_02.svg';

const AccessibilitySetting = () => {

    const [hiContrast, setHiContrast] = useState(false);
    const [fontSize, setFontSize] = useState("basic"); // 기본값: basic

    // 처음 렌더링 시 localStorage 값 불러오기
    useEffect(() => {
        const savedContrast = localStorage.getItem("hiContrast");
        const savedFont = localStorage.getItem("fontSize");

        if (savedContrast !== null) {
            setHiContrast(savedContrast === "true");
        }
        if (savedFont) {
            setFontSize(savedFont);
        }
    }, []);


    // 고대비 상태 토글
    const handleHiContrast = (value) => {
        setHiContrast(value);
        localStorage.setItem("hiContrast", value);
    };

    // hiContrast 상태가 바뀔 때마다 고대비 모드 on/off
    useEffect(() => {
        if (hiContrast) {
            document.documentElement.classList.add("high-contrast");
        } else {
            document.documentElement.classList.remove("high-contrast");
        }
    }, [hiContrast]);

    // 폰트 크기 변경
    const handleFontSize = (value) => {
        setFontSize(value);
        localStorage.setItem("fontSize", value);
    };

    // fontSize 상태 적용
    useEffect(() => {
        document.documentElement.classList.remove("font-basic", "font-medium", "font-large");
        document.documentElement.classList.add(`font-${fontSize}`);
    }, [fontSize]);

    return (
        <>
            <HeadSub title="화면 고대비 설정" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    
                    <div className={style['push-alarm-box']}>
                        <div className={style['top']}>
                            <strong>고대비 설정</strong>
                            <SwitchBox toggles={hiContrast} status={handleHiContrast} />
                        </div>
                    </div>

                    <div className={style['cont-box']}>
                        <div className={style['txt-box']}>
                            <p>
                                <b>고대비 모드</b> 를 활성화하면 <br/>
                                <b>텍스트가 더 뚜렷하게 표시</b>됩니다.
                            </p>
                        </div>

                        <div>
                        <div className={style['img-box']}>
                            <div className={style['left']}>
                                <object 
                                    data={contrast01} 
                                    type="image/svg+xml" 
                                    aria-hidden='true'
                                    style={{ 
                                        pointerEvents: 'none',
                                        width: '80px',
                                        height: '166px',
                                        display: 'block'
                                    }}
                                >  
                                </object>
                               
                                <p>일반 모드</p>
                            </div>
                            <div className={style['mid']}>
                                <object 
                                    data={contrastArrow} 
                                    type="image/svg+xml" 
                                    aria-hidden='true'
                                    style={{ 
                                        pointerEvents: 'none',
                                        width: '14px',
                                        height: '24px',
                                        display: 'block'
                                    }}
                                >
                                </object>
                            </div>
                            <div className={style['right']}>
                                <object 
                                    data={contrast02} 
                                    type="image/svg+xml" 
                                    aria-hidden='true'
                                    style={{ 
                                        pointerEvents: 'none',
                                        width: '80px',
                                        height: '166px',
                                        display: 'block'
                                    }}
                                >
                                </object>
                                <p>고대비 모드</p>
                            </div>
                        </div>                            
                        </div>                
                    </div>

                    <div className={style['text-size-box']}>
                        <strong>텍스트 크기 설정</strong>        


                        <ul className={style['select-list-ul']}>
                            <li>
                                <div className='radio-selectbox' data-style="basic" data-direct="column">
                                    <input 
                                        type="radio" 
                                        id="font01" 
                                        name="font-select" 
                                        checked={fontSize === "basic"} 
                                        onChange={() => handleFontSize("basic")} 
                                    />
                                    <label htmlFor="font01">
                                        <span>기본</span>
                                    </label>
                                </div>  
                            </li>
                            <li>
                                <div className='radio-selectbox' data-style="basic" data-direct="column">
                                    <input 
                                        type="radio" 
                                        id="font02" 
                                        name="font-select" 
                                        checked={fontSize === "medium"} 
                                        onChange={() => handleFontSize("medium")} 
                                    />
                                    <label htmlFor="font02">
                                        <span>중간</span>
                                    </label>
                                </div>
                            </li>
                            <li>
                                <div className='radio-selectbox' data-style="basic" data-direct="column">
                                    <input 
                                        type="radio" 
                                        id="font03" 
                                        name="font-select" 
                                        checked={fontSize === "large"} 
                                        onChange={() => handleFontSize("large")} 
                                    />
                                    <label htmlFor="font03">
                                        <span>크게</span>
                                    </label>
                                </div>
                            </li>
                        </ul>


                    </div>



                </div>
            </div>

        </>
    );
};

export default AccessibilitySetting;